"use client";

import { useEffect } from "react";

export default function ImageHandler() {
  useEffect(() => {
    const imgs = document.querySelectorAll("img");
    imgs.forEach((img) => {
      img.setAttribute("loading", "lazy");
      img.setAttribute("draggable", "false");
    });
  }, []);

  return null;
}
